export const getTimeLeftInSeconds = endTimeInMs => {
    return Math.floor((endTimeInMs - Date.now()) / 1000);
};

/**
 * Calculates and end time that expires in the same amount of time as on server.
 * @param {*} serverTimeInms
 * @param {*} serverlatency
 * @param {*} clientTimeInMs
 * @param {*} itemEndTimeInMs
 */
export const calculateClientEndTime = (
    serverTimeInms,
    serverlatency,
    clientTimeInMs,
    itemEndTimeInMs
) => {
    const diff = serverTimeInms - clientTimeInMs;
    const adjustedEndTime = itemEndTimeInMs - diff - serverlatency;
    return adjustedEndTime;
};
